import { gql } from "@apollo/client";

export const ARMAR_TABLA = gql`
mutation armarTablaProcesarFacturas($mes: Int!, $anio: Int!) {
    armarTablaProcesarFacturas(mes: $mes, anio: $anio) {
        success
        valorEsperado
        error
    }
}`;